// frontend/src/pages/InstitutionalSolutions.jsx

import React from "react";

const InstitutionalSolutions = () => {
  return (
    <main style={{ padding: "60px 20px" }}>
      <div style={{ maxWidth: "1100px", margin: "0 auto" }}>

        {/* PAGE IMAGE */}
        <img
          src="/images/institutional-office.png"
          alt="Institutional Air Purification Solutions"
          style={{
            width: "100%",
            maxHeight: "420px",
            objectFit: "cover",
            borderRadius: "12px",
            marginBottom: "40px"
          }}
        />

        <h1 style={{ fontSize: "36px", marginBottom: "20px" }}>
          Institutional & Commercial Air Purification Solutions
        </h1>

        <p style={{ fontSize: "18px", color: "#555", marginBottom: "30px" }}>
          Aerzen Air provides high-performance air purification systems designed for
          large indoor environments where air quality, reliability, and scalability
          are critical. Our solutions are engineered specifically for Indian AQI
          conditions and continuous-duty operation.
        </p>

        <h2 style={{ fontSize: "26px", marginBottom: "12px" }}>
          Suitable Applications
        </h2>

        <ul style={{ fontSize: "17px", color: "#444", lineHeight: "1.8" }}>
          <li>Corporate offices and IT parks</li>
          <li>Hospitals, clinics, and healthcare facilities</li>
          <li>Schools, colleges, and educational campuses</li>
          <li>Hotels, convention centres, and auditoriums</li>
          <li>Government and public infrastructure buildings</li>
        </ul>

        <h2 style={{ fontSize: "26px", marginTop: "40px", marginBottom: "12px" }}>
          Deployment Approach
        </h2>

        <p style={{ fontSize: "17px", color: "#555" }}>
          Institutional deployments are planned based on area coverage, occupancy,
          airflow requirements, and operating hours. Aerzen Air systems support
          multi-unit installations and centralized planning for consistent indoor
          air quality across multiple rooms or floors.
        </p>

        <div style={{ marginTop: "40px" }}>
          <a
            href="mailto:sales@aerzenair.com"
            style={{
              display: "inline-block",
              padding: "14px 28px",
              backgroundColor: "#0a2540",
              color: "#ffffff",
              textDecoration: "none",
              borderRadius: "6px",
              fontWeight: "600"
            }}
          >
            Request Institutional Proposal
          </a>
        </div>
      </div>
    </main>
  );
};

export default InstitutionalSolutions;
